module.exports = __webpack_public_path__ + "img/client1.4888354d.png";